import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import useLeadsWithFocusArea from "../../hooks/useLeadsWithFocusArea";
import useLeadsWithGlobalFilters from "../../hooks/useLeadsWithGlobalFilters";
import { useLeadStore } from "../../index";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import LeadsGrid from "../leads/LeadsGrid";

function CompanyDetailsLeadsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const leadStore = useLeadStore();
    const leads = useLeadsWithFocusArea(useLeadsWithGlobalFilters(
        useMemo(() => computed(() => leadStore.leads.filter(l => l.pipedriveCompanyId && l.pipedriveCompanyId.toString() === id)), [id]).get()
    ));

    useEffect(() => setEntityCount(leads.length), [leads]);

    if (!visible)
        return null;

    return (
        <LeadsGrid leads={leads} />
    );
}

export default observer(CompanyDetailsLeadsTab);